<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <el-button size="mini" @click="beforeCreateAddress">新建收货地址</el-button>
        <span class="address-msg">您已创建{{addlist.length}}个收货地址，最多可创建20个</span>
      </div>
      <div>
        <el-card class="box-card address-item" shadow="hover" v-for="(item,index) in addlist" v-bind:key="index">
          <div class="">
            <div class="address-hd">
              <div class="name">{{item.receive}}</div>
              <div class="phone">{{item.phone}}</div>
            </div>
            <div class="address-info">
              <p>{{(item.province=="其他"?"":item.province)+' '+(item.city=="其他"?"":item.city) +' '+(item.area=="其他"?"":item.area) +' '+ item.address}}</p>
            </div>
            <div class="address-ft">
              <div class="add-radio">
                <el-radio @change="handleRadioChange" :disabled="item.is_default==1?true:false" v-model="radio" :label="item.id">{{item.is_default==1?'默认地址':'设为默认'}}</el-radio>
              </div>
              <div class="button-sp-area">
                <span class="edit" @click="beforeUpdateAddress(item)">编辑</span>
                <span class="edit del" @click="deleteAdress(item.id)">删除</span>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </el-card>
    <dialogAddress @close="handleFormVisibleClose" @dialogTarget="handleDialogTarget" :form="form" :dialog="dialogFormVisible"></dialogAddress>
  </div>
</template>

<style lang="scss" scoped>
.address-item {
  margin-top: 10px;
}
.address-msg {
  margin-left: 10px;
  color: #aaa;
}
.address-hd {
  font-size: 20px;
  display: flex;
  line-height: 40px;
  height: 40px;
  .name {
    font-weight: bold;
  }
}
.address-info {
  font-size: 18px;
  color: #aaa;

  p {
    margin-top: 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #dddddd;
  }
}
.address-ft {
  display: flex;
  justify-content: space-between;
  .edit + .edit {
    margin-left: 5px;
  }
  .del {
    color: #d21721;
  }
}
</style>
<style lang="scss">
.add-radio .el-radio .el-radio__label {
  font-size: 16px;
}
</style>
<script>
import dialogAddress from '../../components/dialogAddress'
import {
  Usercenter
} from "../../model/usercenter.js";
let usercenter = new Usercenter();
export default {
  name: 'address1',
  data() {
    return {
      radio: '',
      addlist: [],
      dialogFormVisible: false,
      form: {
        value: [''],
        phone: "",
        receive: "",
        address: "",
        isDefault: false,
        selectArr: [],
        radioIndex: ""
      }
    }
  },
  components: {
    dialogAddress
  },
  methods: {
    getAddressByCustomsId() {
      let _this = this;
      usercenter.addressByCustomsId({
        is_default: 0,
        customer_id: _this.user ? _this.user.id : ""
      }).then(function (res) {
        _this.addlist = res;
        let index = res.findIndex(item => item.is_default === 1);
        if (index >= 0) {
          _this.radioIndex = index;
          _this.radio = res[index].id;
        } else {
          _this.radioIndex = "";
          _this.radio = "";
        }
      })
    },
    handleCloseDialog() {
      this.resetValue();
    },
    handleRadioChange(data) {
      let _this = this;
      _this.setDefaultAddress(data)
    },
    deleteAdress(id) {
      let _this = this;
      usercenter.deleteAdress({
        id: id
      }).then(() => {
        _this.$message({
          message: '删除成功',
          type: 'success'
        });
        _this.getAddressByCustomsId()
      })
    },
    setDefaultAddress(data) {
      let _this = this;
      let index = _this.addlist.findIndex(item => item.id === data);
      let tempIndex = _this.radioIndex;
      if (index >= 0) {
        if (tempIndex) {
          _this.addlist[tempIndex].is_default = false;
        }
        _this.radio = _this.addlist[index].id;
        _this.addlist[index].is_default = true;
        _this.radioIndex = index;
      }
      usercenter.defaultAddress({
        id: data,
        customer_id: _this.user ? _this.user.id : ""
      }).then(() => {
        _this.$message({
          message: '设置默认地址成功',
          type: 'success'
        });
      }, () => {
        if (tempIndex) {
          _this.radio = _this.addlist[tempIndex].id;
          _this.radioIndex = tempIndex;
        }

      })
    },
    handleFormVisible() {
      this.dialogFormVisible = true;
    },
    handleFormVisibleClose() {
      this.dialogFormVisible = false;
    },
    handleChange(data) {
      this.form.selectArr = data;
    },
    handleUpdateAddress(item) {
      let _this = this;
      let arr = [];
      arr[0] = item.province;
      arr[1] = item.city;
      arr[2] = item.area;
      _this.form.id = item.id;
      _this.form.address = item.address;
      _this.form.receive = item.receive;
      _this.form.phone = item.phone;
      _this.form.selectArr = arr;
      _this.form.value = arr;
      _this.form.isDefault = item.is_default ? true : false;
    },
    beforeUpdateAddress(item) {
      this.handleFormVisible();
      this.handleUpdateAddress(item)
    },
    resetValue() {
      let _this = this;
      _this.form.id = '';
      _this.form.address = '';
      _this.form.receive = '';
      _this.form.phone = '';
      _this.form.selectArr = [];
      _this.form.value = [''];
      _this.form.isDefault = false;
    },
    beforeCreateAddress() {
      let _this = this;
      _this.resetValue();
      this.handleFormVisible();
    },
    handleDialogTarget(data) {
      let _this = this;
      if (data.msg) {
        _this.$message({
          message: '新建地址成功',
          type: 'success'
        });
        //获取地址列表重新
        _this.getAddressByCustomsId()
      } else {
        _this.$message({
          message: data.data,
          type: 'error'
        });
      }
    }
  },
  created() {
    this.getAddressByCustomsId()
  }
}
</script>